/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'layers': {
    width: 1000,
    height: 1000,
    viewBox: '0 0 1000 1000',
    data: '<path pid="0" d="M499.5 470l438-157.4-436-158.2h-2.1l-437 158.2 436 157.4h1.1zm.1 113.2l-190.8-69.6L171.3 563l328.3 119 329.1-119-137.5-49.4-191.6 69.6zm0 162.9l-190.8-68.7-137.5 49.4 328.3 119 329.1-119-137.5-49.4-191.6 68.7z"/>'
  }
})
